import { Link } from "react-router-dom";
import { clearConsent } from "@/lib/consent";

export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white mt-auto dark:border-slate-800 dark:bg-slate-950">
      <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
        <div>
          <div className="font-semibold tracking-tight text-slate-900 dark:text-slate-100">
            Reputely
          </div>
          <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Reputation defense for Amazon sellers.
          </div>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-600 dark:text-slate-400">
          <Link to="/audit" className="hover:text-slate-900 dark:hover:text-slate-100">
            Free audit
          </Link>
          <Link to="/how-it-works" className="hover:text-slate-900 dark:hover:text-slate-100">
            How it works
          </Link>
          <Link to="/pricing" className="hover:text-slate-900 dark:hover:text-slate-100">
            Pricing
          </Link>
          <Link to="/faq" className="hover:text-slate-900 dark:hover:text-slate-100">
            FAQ
          </Link>
          <Link to="/terms" className="hover:text-slate-900 dark:hover:text-slate-100">
            Terms
          </Link>
          <Link to="/privacy" className="hover:text-slate-900 dark:hover:text-slate-100">
            Privacy
          </Link>
          <button
            type="button"
            onClick={clearConsent}
            className="text-left hover:text-slate-900 dark:hover:text-slate-100"
          >
            Cookie preferences
          </button>
        </div>
        <div className="text-xs text-slate-400 dark:text-slate-500">
          © {new Date().getFullYear()} Reputely
        </div>
      </div>
    </footer>
  );
}
